'use strict';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

const $ = jQuery.noConflict();
$(function() {

	const siteFooter = {

		init: function() {
			this.cacheDOM();
			if (!this.footer) {
				return;
			}
			if (this.prefersReducedMotion()) {
				return;
			}
			gsap.registerPlugin(ScrollTrigger);
			this.createTimeline();
		},

		cacheDOM: function() {
			this.footer = document.querySelector('.js-site-footer');
			if (!this.footer) {
				return;
			}
			this.logo = this.footer.querySelector('.js-site-footer-logo');
			this.nav = this.footer.querySelector('.js-site-footer-nav');
		},

		prefersReducedMotion: function() {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		},

		createTimeline: function() {
			const startScale = 1.6;

			gsap.set(this.logo, {scale: startScale, transformOrigin: 'top left'});
			gsap.set(this.nav, {opacity: 0, y: 40});

			const tl = gsap.timeline({
				defaults: {ease: 'power1.inOut'},
				scrollTrigger: {
					trigger: this.footer,
					start: 'top bottom-=200',
					end: 'bottom bottom',
					scrub: 1,
					invalidateOnRefresh: true,
				},
			});

			tl.to(this.logo, {scale: 1, duration: 0.7}, 0);
			tl.to(this.nav, {opacity: 1, y: 0, duration: 0.3}, 0.7);
		},

	};

	siteFooter.init();
});
